export default __webpack_public_path__ + "static/media/person-32.12f7bd56.svg";